// extracted by mini-css-extract-plugin
export var section = "am34EyS9";
export var lightBlueBg = "y8jO-tIj";